import PropTypes from "prop-types"
import React from "react"

import { useTracker } from "src/hooks/use_tracker"

const ReachOut = ({
  reachOut,
  contractChatUrl,
  marinaId,
  marinaName,
  quoteId,
}) => {
  const tracker = useTracker()
  const { design, mode, phone, phoneUri } = reachOut

  if (mode === "none") return null

  const trackReachOut = (eventName) => {
    tracker.trackEvent(eventName, {
      contract_quote_id: quoteId,
      marina_id: marinaId,
      marina_name: marinaName,
    })
  }

  const handleMessage = () => trackReachOut("contracts_v2:marina_messaged")

  const messageLink = (label, className) => (
    <a
      className={className}
      onClick={handleMessage}
      href={contractChatUrl}
      target="_blank"
      rel="noopener noreferrer"
    >
      {label}
    </a>
  )

  if (design === "legacy") {
    return (
      <div className="rounded-lg border border-gray-300 px-4 py-6">
        <h4 className="mx-0 mb-2 mt-0 font-semibold">Reach Out</h4>
        <p className="mb-4 font-semibold">
          Have a question about this agreement?
        </p>
        {messageLink(`Message ${marinaName}`, "btn btn-tertiary w-full")}
      </div>
    )
  }

  const isCall = mode === "call"

  return (
    <div className="rounded-lg border border-gray-300 px-4 py-6">
      <div className="flex items-center gap-3">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gray-100 text-gray-900">
          <i
            className={isCall ? "fa-solid fa-headset" : "fa-solid fa-life-ring"}
          />
        </span>
        <div className="flex flex-1 flex-col">
          <h4 className="m-0 font-semibold">Need help?</h4>
          <p className="m-0 text-gray-700">
            {isCall ? `Call ${marinaName}` : `Message ${marinaName}`}
          </p>
          {isCall ? (
            <a
              className="mt-1 font-semibold text-blue-600"
              onClick={() => trackReachOut("contracts_v2:marina_called")}
              href={`tel:${phoneUri}`}
            >
              {phone}
            </a>
          ) : (
            messageLink("Message the Marina", "btn btn-tertiary mt-3 w-full")
          )}
        </div>
      </div>
    </div>
  )
}

ReachOut.propTypes = {
  reachOut: PropTypes.shape({
    design: PropTypes.oneOf(["legacy", "needHelp"]).isRequired,
    mode: PropTypes.oneOf(["message", "call", "none"]).isRequired,
    phone: PropTypes.string,
    phoneUri: PropTypes.string,
  }).isRequired,
  marinaName: PropTypes.string.isRequired,
  marinaId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  quoteId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  contractChatUrl: PropTypes.string.isRequired,
}

export default ReachOut
